import { render, staticRenderFns } from "./AskDialog.vue?vue&type=template&id=51480188&scoped=true&"
import script from "./AskDialog.vue?vue&type=script&lang=js&"
export * from "./AskDialog.vue?vue&type=script&lang=js&"
import style0 from "./AskDialog.vue?vue&type=style&index=0&id=51480188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51480188",
  null
  
)

export default component.exports